import { Avatar, Button, DialogTrigger, Input, Tooltip } from "@fluentui/react-components";
import { NavigationRegular, WeatherMoonRegular, WeatherSunnyRegular, DesktopRegular, SearchRegular } from "@fluentui/react-icons";
import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SignOutBtn } from "./SignOutBtn";
import { useThemeMode } from "../contexts/ThemeContext";
import { getNavigationItem } from "../navigation";
import "./Header.css";

const themeIcons = { light: WeatherSunnyRegular, dark: WeatherMoonRegular, system: DesktopRegular };

export const Header = ({ navOpen }) => {
    const { instance, accounts } = useMsal();
    const { mode, cycleMode } = useThemeMode();
    const location = useLocation();
    const navigate = useNavigate();
    const [query, setQuery] = useState("");
    const account = instance.getActiveAccount() || accounts[0];
    const item = getNavigationItem(location.pathname);
    const ThemeIcon = themeIcons[mode];

    useEffect(() => {
        setQuery(location.pathname === "/" ? new URLSearchParams(location.search).get("q") || "" : "");
    }, [location.pathname, location.search]);

    return (
        <div className="app-header">
            <DialogTrigger disableButtonEnhancement>
                <Button className="app-header-hamburger" appearance="subtle" icon={<NavigationRegular />}
                    aria-label="Open navigation" aria-expanded={navOpen} />
            </DialogTrigger>
            <div className="app-breadcrumb"><span>{item?.group || "Workspace"}</span><span aria-hidden="true">/</span><strong>{item?.label || "Function details"}</strong></div>
            {location.pathname !== "/" && <form className="app-header-search" role="search" onSubmit={event => {
                event.preventDefault();
                navigate(query.trim() ? `/?q=${encodeURIComponent(query.trim())}` : "/");
            }}>
                <Input value={query} onChange={(_, data) => setQuery(data.value)} contentBefore={<SearchRegular />}
                    contentAfter={<span className="search-enter" aria-hidden="true">Enter</span>}
                    placeholder="Find a function..." aria-label="Find a function" className="app-header-searchbox" />
            </form>}
            <div className="app-header-actions">
                <Tooltip content={`${mode} theme. Change theme`} relationship="label">
                    <Button appearance="subtle" icon={<ThemeIcon />} aria-label={`Change theme (${mode})`} onClick={cycleMode} />
                </Tooltip>
                <span className="account-divider" />
                <Avatar name={account?.name || account?.username || "Account"} aria-label={account?.name || "Account"} color="brand" size={32} />
                <SignOutBtn />
            </div>
        </div>
    );
};
